/* Client-side Instagram username extraction. Ported from convex/sources.ts. */

const INSTAGRAM_RESERVED_PATHS = new Set([
  "p",
  "reel",
  "reels",
  "tv",
  "explore",
  "stories",
  "accounts",
  "about",
  "developer",
  "press",
  "privacy",
  "terms",
  "policies",
  "directory",
]);

function isValidInstagramHandle(handle: string): boolean {
  return /^[A-Za-z0-9._]{1,30}$/.test(handle);
}

export function extractInstagramUsername(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const withoutAt = trimmed.startsWith("@") ? trimmed.slice(1) : trimmed;
  if (!trimmed.includes("instagram.com")) {
    return isValidInstagramHandle(withoutAt) ? withoutAt : null;
  }

  try {
    const normalized = trimmed.startsWith("http")
      ? trimmed
      : `https://${trimmed}`;
    const url = new URL(normalized);
    if (!url.hostname.includes("instagram.com")) return null;
    const path = url.pathname.replace(/^\/+|\/+$/g, "");
    if (!path) return null;
    const [segment] = path.split("/");
    if (!segment) return null;
    const cleaned = segment.startsWith("@") ? segment.slice(1) : segment;
    if (INSTAGRAM_RESERVED_PATHS.has(cleaned.toLowerCase())) return null;
    return isValidInstagramHandle(cleaned) ? cleaned : null;
  } catch {
    return null;
  }
}
